import { Link, useNavigate } from "react-router-dom";
import SelectBox from "../SelectBox";
import {
  faqUrl,
  populateFaqSearchResult,
  useFaqData
} from "../../hooks/FaqHooks";
import { FaqSearchResult } from "../../types/Faq";
import { useLang } from "../../hooks/LangHooks";
import { algoliaFaqSearch } from "../../services/algoliaService";
import { CSSProperties, useCallback } from "react";
import "./style.scss";

const FaqSearchResultItem = ({
  item: { article, category }
}: {
  item: Partial<FaqSearchResult>;
}) => {
  return (
    <Link
      to={faqUrl({ category, article })}
      onClick={e => {
        //The link should only handle "open in new tab/window"
        e.preventDefault();
        return false;
      }}
    >
      <div className="cat-label">{category?.name}</div>
      <div className="question">{article?.title}</div>{" "}
    </Link>
  );
};

const FaqItemSearchBox = ({
  initialValue,
  onChange,
  allowCustomInput = false,
  placeholder = "",
  hintText = "",
  noMatchText = "",
  id = "",
  className = "",
  style = {}
}: {
  initialValue?: object;
  onChange?: (_item: FaqSearchResult) => void;
  placeholder?: string;
  hintText?: string;
  noMatchText?: string;
  allowCustomInput?: boolean;
  id?: string;
  className?: string;
  style?: CSSProperties;
}) => {
  const navigate = useNavigate();
  const lang = useLang();
  const faqData = useFaqData(lang);

  const faqSearch = useCallback(
    async (query: string, limit = 8) => {
      const { faqArticles } = await algoliaFaqSearch(query, limit, lang);
      //console.log("faqSearch", faqArticles);
      return populateFaqSearchResult(faqData, faqArticles);
    },
    [faqData, lang]
  );

  return (
    <SelectBox
      ItemComponent={FaqSearchResultItem}
      SelectedValueDisplay={null}
      itemIdField={["article", "id"]}
      itemTitleField={["article", "title"]}
      searchFn={faqSearch}
      initialValue={initialValue}
      onChange={item => {
        const { article, category } = item as FaqSearchResult;
        if (article?.id && category?.id) {
          navigate(faqUrl({ category, article }));
        }
        if (typeof onChange == "function") {
          onChange(item as FaqSearchResult);
        }
      }}
      allowCustomInput={allowCustomInput}
      placeholder={placeholder}
      hintText={hintText}
      noMatchText={noMatchText}
      id={id}
      className={className}
      itemClassName="faq-search-result-item"
      style={style}
    />
  );
};

export default FaqItemSearchBox;
